import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import ButtonCta from '@components/atoms/button-cta'
import InfoAndImageCard from '@components/info-and-image-card'
import CtaBox from '@components/cta-box/'
import useStyles from './path-to-golf.styles'

const PathToGolf = (props) => {
  const {
    sectionHeading,
    sectionSupportiveCopy,
    backgroundImage,
    ctaButtonLabel,
    ctaButtonLink,
    trackCardsCollection,
    ctaBoxHeadline,
    ctaBoxSubtitle,
    ctaBoxButtonLabel,
    ctaBoxButtonLink,
  } = props

  const styles = useStyles()

  return (
    <div id="path-to-golf" className={`${styles.root}`}>
      <div className={styles.bgImageContainer}>
        {backgroundImage?.url && (
          <img src={backgroundImage.url} alt="" className={styles.bgImage} />
        )}
      </div>
      <Container>
        <div className={styles.introContainer}>
          <div>
            <h2 className={styles.heading}>{sectionHeading}</h2>
            <p className={styles.supportiveCopy}>{sectionSupportiveCopy}</p>
          </div>
          {(ctaButtonLink && ctaButtonLabel) && (
            <div className={styles.ctaContainer}>
              <ButtonCta
                color="primary"
                variant="outlined"
                href={ctaButtonLink}
                dataAttrs={{ 'aria-label': `${ctaButtonLabel}` }}
              >
                {ctaButtonLabel}
              </ButtonCta>
            </div>
          )}
        </div>
        <Box className={styles.infoCardsContainer}>
          {trackCardsCollection?.items
            && trackCardsCollection.items.map((cardData, i) => (
              <InfoAndImageCard {...cardData} key={`path-to-golf-info-card-list-item-${i + 1}`} />
            ))}
        </Box>
        <CtaBox
          ctaBoxText={ctaBoxHeadline}
          ctaBoxLinkText={ctaBoxButtonLabel}
          ctaBoxSubtitle={ctaBoxSubtitle}
          ctaBoxUrl={ctaBoxButtonLink}
          variant
        />
      </Container>
    </div>
  )
}

PathToGolf.propTypes = {
  sectionHeading: PropTypes.string,
  sectionSupportiveCopy: PropTypes.string,
  backgroundImage: PropTypes.object,
  ctaButtonLabel: PropTypes.string,
  ctaButtonLink: PropTypes.string,
  trackCardsCollection: PropTypes.object,
  ctaBoxHeadline: PropTypes.string,
  ctaBoxSubtitle: PropTypes.string,
  ctaBoxButtonLabel: PropTypes.string,
  ctaBoxButtonLink: PropTypes.string,
}

PathToGolf.defaultProps = {}

export default PathToGolf
